<greco-tile-details [tile]="tile"></greco-tile-details>
